import React from 'react';
import { Box, Typography, Button, Paper, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CelebrationIcon from '@mui/icons-material/Celebration';
import InventoryIcon from '@mui/icons-material/Inventory';
import HandymanIcon from '@mui/icons-material/Handyman';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
const Dashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const featureCards = [
    {
      icon: <InventoryIcon fontSize="large" sx={{ color: "#00BFFF" }} />,
      title: "Stock Management",
      description: "Manage your entire stock with real-time updates",
      action: () => navigate('/stock')
    },
    {
      icon: <HandymanIcon fontSize="large" sx={{ color: "#00BFFF" }} />,
      title: "Repaire/Service",
      description: "Manage customer services and repairs efficiently",
      action: () => navigate('/repair')
    },
    {
      icon: <CurrencyExchangeIcon fontSize="large" sx={{ color: "#00BFFF" }} />,
      title: "Expense",
      description: "Track and manage your expenses seamlessly",
      action: () => navigate('/expense')
    }
  ];

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      p: 4
    }}>
      <Paper elevation={6} sx={{
        p: 6,
        borderRadius: 4,
        maxWidth: 'md',
        width: '100%',
        textAlign: 'center',
        background: theme.palette.mode === 'dark'
          ? 'rgba(33, 33, 33, 0.8)'
          : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(8px)',
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          mb: 4
        }}>
          <CelebrationIcon sx={{
            fontSize: 60,
            color: "#00BFFF"
          }} />
          <Typography variant="h3" component="h1" sx={{
            fontWeight: 700,
            background: theme.palette.mode === 'dark'
              ? 'linear-gradient(45deg, #00BFFF, #1E90FF)'  // Dark mode: light blue to dodger blue
              : 'linear-gradient(45deg, #00BFFF, #0066CC)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2
          }}>
            Welcome to Engage 24x7 Portal
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '70%' }}>
            Your comprehensive platform for managing employee and salaries
          </Typography>
        </Box>

        

        <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center', gap: 2 }}>

        </Box>
      </Paper>
    </Box>
  );
};

export default Dashboard;